import SvgIcon from "@material-ui/core/SvgIcon";

export const TickInCircleIcon = ({
  color = "black",
  backgroundColor = "transparent",
  ...props
}) => (
  <SvgIcon
    {...props}
    component="svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <circle cx="12" cy="12" r="12" fill={backgroundColor} />

    <path
      d="M7 12.5l3 3.5 7-8.5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
